import script from "./jaugeRegimeAlimentaire.vue?vue&type=script&setup=true&lang=js"
export * from "./jaugeRegimeAlimentaire.vue?vue&type=script&setup=true&lang=js"

import "./jaugeRegimeAlimentaire.vue?vue&type=style&index=0&id=b148dfe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b148dfe8"]])

export default __exports__